var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageCarousel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47px",
    height: "47px",
    viewBox: "0 0 47 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Project-Editor-4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2272727,29.9090909 C19.2272727,28.7298182 20.1843636,27.7727273 21.3657727,27.7727273 C22.5471818,27.7727273 23.5,28.7298182 23.5,29.9090909 C23.5,31.0883636 22.5471818,32.0454545 21.3657727,32.0454545 C20.1843636,32.0454545 19.2272727,31.0883636 19.2272727,29.9090909 Z M32.2163636,29.9090909 L28.9477273,34.9081818 L26.4481818,31.8318182 L20.2954545,39.5227273 L39.5227273,39.5227273 L32.2163636,29.9090909 Z M47,19.2272727 L47,47 L11.75,47 L11.75,19.2272727 L47,19.2272727 Z M43.7954545,23.5 L16.0227273,23.5 L16.0227273,42.7272727 L43.7954545,42.7272727 L43.7954545,23.5 Z M30.7837053,5.05238536 L35.229492,15.4566283 L39.5227273,15.4566283 L32.9174452,0 L0,13.3757797 L7.92475358,32.0454545 L7.92475358,21.8730611 L5.18278884,15.4566283 L30.7837053,5.05238536 Z",
    id: "Shape",
    fill: "#4A4A4A",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageCarousel);
export default __webpack_public_path__ + "static/media/Image Carousel.780e1d8d.svg";
export { ForwardRef as ReactComponent };